<div class="transport">
  <div class="header p-16 p-sm-24"
       fxLayout.gt-xs="row"
       fxLayoutAlign.gt-xs="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="logo" fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          local_shipping
        </mat-icon>
        <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
          {{'TRANSPORT.TITLE_LIST' | translate}}
        </span>
      </div>
    </div>
    <div class="search-wrapper">
      <div class="search">
        <label for="name" class="mr-8">
          <mat-icon (click)="clearSearch()">{{searchTransport.value ? 'clear' : 'search'}}</mat-icon>
        </label>
        <input id="name" [formControl]="searchTransport"
               [placeholder]="'TRANSPORT.SEARCH_PLACEHOLDER' | translate">
      </div>
    </div>
  </div>

  <div class="transport-content">
    <app-list-filters class="filters-container"
                      [filters]="['active']"
                      (listFilters)="getListFilters($event)">
    </app-list-filters>
    <div class="transport-table">
      <mat-table matSort
                 [dataSource]="dataSource"
                 [matSortActive]="requestParams.sort"
                 [matSortDirection]="requestParams.order"
                 [@animateStaggerRemondis]="dataSource.length"
                 [@.disabled]="disableAnimations">

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TRANSPORT.NAME' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let transport">{{transport.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>{{'TRANSPORT.DESC' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let transport">{{transport.description}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="capacity">
          <mat-header-cell *matHeaderCellDef>{{'TRANSPORT.CAPACITY' | translate}} [T]</mat-header-cell>
          <mat-cell *matCellDef="let transport"> {{transport.capacity}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="volume">
          <mat-header-cell *matHeaderCellDef>{{'TRANSPORT.VOLUME' | translate}} [m<sup>3</sup>]
          </mat-header-cell>
          <mat-cell *matCellDef="let transport"> {{transport.volume}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="category">
          <mat-header-cell *matHeaderCellDef>{{'TRANSPORT.CATEGORY' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let transport"> {{('TRANSPORT.CATEGORIES.' + transport.category) | translate}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{'TRANSPORT.STATUSES.ACTIVE' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let transport">
            <mat-icon [ngClass]="transport.active && 'green-icon'">
              {{transport.active ? 'check' : 'close'}}
            </mat-icon>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          class="transport-row"
          *matRowDef="let transport; columns: displayedColumns;"
          [@animateRemondis]="{value:'*',params:{y:'100%'}}"
          [id]="transport.uuid"
          (click)="viewTransport(transport.uuid)">
        </mat-row>

      </mat-table>

      <h4 class="no-data" *ngIf="totalCount === 0">
        {{'SHARED.NO_DATA' | translate}}
      </h4>

      <div *ngIf="totalCount" class="paginator-container">
        <mat-paginator
          (page)="pageChange($event)"
          [pageSize]="requestParams.limit"
          [pageIndex]="(requestParams.page - 1)"
          [length]="totalCount"
          class="paginator-holder">
        </mat-paginator>
      </div>
    </div>
  </div>
  <button mat-fab class="add-transport-button"
          [@animate]="{value:'*', params:{delay:'300ms',scale:'.2'}}"
          [matTooltip]="'TRANSPORT.TITLE_ADD' | translate"
          [attr.data-cy]="'transportAdd'"
          matTooltipPosition="above"
          (click)="addTransport()">
    <mat-icon>add</mat-icon>
  </button>
</div>